import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdjustmentsHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 6l8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 6l4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 12l2 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 12l10 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 18l11 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 18l1 0" })
	]
});
export { SvgAdjustmentsHorizontal as ReactComponent };
